import type { MALE_ID, FEMALE_ID, UNKNOWN_GENDER_ID } from '@app/constants';

import type { Dayjs } from 'dayjs';

export namespace NSmallGlobalEntities {
  export type Gender = typeof MALE_ID | typeof FEMALE_ID | null;
  export type GenderForForm =
    | typeof MALE_ID
    | typeof FEMALE_ID
    | typeof UNKNOWN_GENDER_ID;
  export type Phone = string | null;
  export type TelCode = string | null;
  export type PhoneCountryId = number | null;
  export type RangeValue = [Dayjs | null, Dayjs | null] | null;
  export type SearchId = number;
  export type Date = string | null;
  export type ModelItem = {
    Id: number;
    IdS: string | null;
    Name: string | null;
    IsDeleted?: boolean;
  };
  export type SocialIntegrationModelItem = {
    Id: number;
    IdS: string | null;
    Name: string | null;
    BranchId: number | null;
    BranchName: string | null;
  };
}
